import { render, staticRenderFns } from "./ImprimirReporteBuroCredito.vue?vue&type=template&id=ad56cc46&scoped=true&"
import script from "./ImprimirReporteBuroCredito.vue?vue&type=script&lang=js&"
export * from "./ImprimirReporteBuroCredito.vue?vue&type=script&lang=js&"
import style0 from "./ImprimirReporteBuroCredito.vue?vue&type=style&index=0&id=ad56cc46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad56cc46",
  null
  
)

export default component.exports